import * as React from "react";
export { Footer };
 function Footer() {
    return (
      <>
      
      </>
    );
  }